<template>
	<splash v-show="isLoading" title="수능모의평가 준비중..." />
	<splash v-show="isProc" title="잠시만 기다려 주세요." />
	<CsatHeader
		v-show="!isLoading"
		:timerEnable="isStart"
		:isPause="isPause"
		:baseTime="baseTime"
		:headerInfo="headerInfo"
		:problemOrder="problemOrder"
		@nextStep="nextStep"
		:bottom-hide="bottomHide"
		:scoreVisible="scoreVisible"
	/>
	<q-page-container v-if="!scoreVisible">
		<q-page
			class="q-pa-md color_gray_900"
			style="height: calc(100vh - 7.77vmin)"
		>
			<div class="row" v-if="isStart">
				<div class="col passage">
					<qbankHeaderVue
						:currentNo="arrHeaderNo[problem.problemNo - 1]"
						:questionHeader="
							headerList[problem?.headerId] ? null : problem?.questionHeader
						"
						:inputIdx="inputIdx"
						:bookNm="bookNm"
						@isChangeHeader="
							() => {
								isChangeHeader = true;
							}
						"
						:reviewHeader="headerList[problem?.headerId]"
					/>
				</div>
				<div class="col answer">
					<!-- <qbankProblem :p-content="problem" v-if="tab === item.index" @setCheckedAnswer="setCheckedAnswer"
              @onChangeProblems="onChangeProblems" @setProblemResult="setProblemResult" /> -->
					<q-scroll-area
						ref="scrollAreaRef"
						visible
						class="answer__scroll"
						style="height: 100%"
					>
						<div>
							<problemChoice
								:p-content="problem"
								:isCsat="true"
								v-if="problem"
								@setAnswer="setAnswer"
							/>
						</div>
						<!-- 임시 정답표시-->
						<!-- <div>{{
                problems[problemOrder]?.data.content.solution.answer.detail[0].answer
            }}</div> -->
						<div v-if="visibleAnswer">
							{{
								problems[problemOrder]?.data.content.solution.answer.detail[0]
									.answer
							}}
						</div>
						<div>
							<qbankAnswer
								:p-content="problem"
								v-if="problems[problemOrder]?.result"
								@onIntersection="onIntersection"
								@setVideoStatus="setVideoStatus"
							/>
						</div>
					</q-scroll-area>
				</div>
			</div>
			<div v-if="!isStart" style="height: 100%">
				<div class="color_gray_900 page__content">
					<div class="page__inner">
						<div class="page__title">
							<p class="title_level">
								{{ studyStore?.process?.exam?.level }}레벨
								{{
									studyStore?.process?.exam?.satOrder
										? studyStore?.process?.exam?.satOrder + '회차'
										: ''
								}}
							</p>
							<p class="title_sub">수능모의평가 문제지</p>
							<p class="title">국어 영역</p>
						</div>
						<div class="display_flex sat__content">
							<div class="display_flex panel">
								<p class="panel__img">
									<img src="@/assets/images/icon/ico_total.png" />
								</p>
								<p class="h3 bold txt_center">
									34문항<span class="display_block b3 medium"
										>(비문학 17문항 / 문학 17문항)</span
									>
								</p>
							</div>
							<div class="display_flex panel">
								<p class="panel__img">
									<img src="@/assets/images/icon/ico_clock_green.png" />
								</p>
								<div
									style="
										display: flex;
										flex-direction: column;
										justify-content: center;
										width: 100%;
									"
								>
									<p class="h3 bold txt_center">60분</p>
									<p
										class="display_block b3 medium"
										style="color: #222222; text-align: center"
									>
										(권장 평가 시간)
									</p>
								</div>
							</div>
						</div>
						<!-- <div style="width: 100%; margin: 20px 0px"> -->
						<div class="panel page__txt">
							전체 34문항에 대한 답안 체크가 모두 완료된 경우에만 최종 제출이
							가능하오니<br />
							한 문항도 빠짐없이 문제를 풀어 주시기 바랍니다.<br />
							평가가 시작되면
							<b
								>60분 동안 진행되며, 중간에 종료할 수 없으므로<br />끝까지
								문제를 풀어 주시기 바랍니다.</b
							>
						</div>
						<p class="mg_top_32">
							<q-btn
								class="btn_start"
								:onClick="testStart"
								color="primary"
								label="평가 시작"
							/>
						</p>
					</div>
				</div>
			</div>
			<FloatingNotify
				:text="msg"
				:icon="msgIcon"
				@resetMsg="
					() => {
						msg = '';
					}
				"
			/>
			<!-- <FloatingBtn :visible="nextBtn" @on-click="() => { nextStep(); }" /> -->
			<FloatingBtn
				:visible="nextBtn"
				:text="problemOrder === 34 ? '완료' : null"
				@on-click="
					() => {
						nextBtn && nextStep();
					}
				"
				:bgColor="problemOrder == 34 ? '#222222' : null"
				:icon="problemOrder == 34 ? 'done' : null"
				:class="nextBtn && problemOrder === 34 ? 'answer--txt' : 'answer--next'"
			/>
			<FloatingBtn
				:visible="preBtn"
				position="left"
				@on-click="
					() => {
						preBtn && nextStep(false);
					}
				"
				class="answer--prev"
			/>
			<FloatingBtn
				:visible="scoreBtn"
				text="최종 제출하기"
				text-only="true"
				bgColor="black"
				@on-click="
					() => {
						scoreBtn && setQuestionsResult();
					}
				"
				class="answer--txt"
				bottom="calc( 15.83vmin - 4.9vw - 0.83vmin )"
			/>
		</q-page>
	</q-page-container>
	<template v-if="scoreVisible">
		<q-page-container class="score__container">
			<div class="score">
				<div class="score__title">채점 결과</div>
				<div class="score__desc">
					평가가 종료되었습니다. 문항에 대한 정오답 여부를 확인해 보세요.
				</div>
				<div class="score__wrap" v-if="headerInfo">
					<div class="score__item" style="width: 50%">
						<div class="score__item__title">비문학</div>
						<div class="score__item__wrap">
							<div class="score__item__left">
								<template v-for="index in 9" :key="index">
									<div class="result">
										<span class="result__num">{{ index }} </span>
										<!-- <div>{{ headerInfo[index]?.result?.marking }}</div> -->
										<!-- <q-icon
                        :name="headerInfo[index]?.result?.marking === 'right' ? 'radio_button_unchecked' : 'close'"
                        :style="headerInfo[index]?.result?.marking !== 'right' ? 'font-size: 1.6vw;color:#FD6956 ;' : 'font-size: 1.6vw;'">
                      </q-icon> -->
										<img
											v-if="headerInfo[index]?.result?.marking === 'right'"
											src="@/assets/images/icon/ico_sat_o.png"
										/>
										<img
											v-if="headerInfo[index]?.result?.marking !== 'right'"
											src="@/assets/images/icon/ico_sat_x.png"
										/>
									</div>
								</template>
							</div>
							<div class="score__item__right">
								<template v-for="index in 8" :key="index">
									<div class="result">
										<span class="result__num">{{ index + 9 }}</span>
										<!-- <div>{{ headerInfo[index + 9]?.result?.marking }}</div> -->
										<!-- <q-icon
                        :name="headerInfo[index + 9]?.result?.marking === 'right' ? 'radio_button_unchecked' : 'close'"
                        :style="headerInfo[index + 9]?.result?.marking !== 'right' ? 'font-size: 1.6vw;color:#FD6956 ;' : 'font-size: 1.6vw;'">
                      </q-icon> -->
										<img
											v-if="headerInfo[index + 9]?.result?.marking === 'right'"
											src="@/assets/images/icon/ico_sat_o.png"
										/>
										<img
											v-if="headerInfo[index + 9]?.result?.marking !== 'right'"
											src="@/assets/images/icon/ico_sat_x.png"
										/>
									</div>
								</template>
							</div>
						</div>
					</div>
					<div class="score__item" style="width: 50%">
						<div class="score__item__title">문학</div>
						<div class="score__item__wrap">
							<div class="score__item__left">
								<template v-for="index in 9" :key="index">
									<div class="result">
										<span class="result__num">{{ index + 17 }}</span>
										<!-- <div>{{ headerInfo[index + 17]?.result?.marking }}</div> -->
										<!-- <q-icon
                        :name="headerInfo[index + 17]?.result?.marking === 'right' ? 'radio_button_unchecked' : 'close'"
                        size="sm"
                        :style="headerInfo[index + 17]?.result?.marking !== 'right' ? 'font-size: 1.6vw;color:#FD6956 ;' : 'font-size: 1.6vw;'">
                      </q-icon> -->
										<img
											v-if="headerInfo[index + 17]?.result?.marking === 'right'"
											src="@/assets/images/icon/ico_sat_o.png"
										/>
										<img
											v-if="headerInfo[index + 17]?.result?.marking !== 'right'"
											src="@/assets/images/icon/ico_sat_x.png"
										/>
									</div>
								</template>
							</div>
							<div class="score__item__right">
								<template v-for="index in 8" :key="index">
									<div class="result">
										<span class="result__num">{{ index + 26 }}</span>
										<!-- <div>{{ headerInfo[index + 26]?.result?.marking }}</div> -->
										<!-- <q-icon
                        :name="headerInfo[index + 26]?.result?.marking === 'right' ? 'radio_button_unchecked' : 'close'"
                        size="sm"
                        :style="headerInfo[index + 26]?.result?.marking !== 'right' ? 'font-size: 1.6vw;color:#FD6956 ;' : 'font-size: 1.6vw;'">
                      </q-icon> -->
										<img
											v-if="headerInfo[index + 26]?.result?.marking === 'right'"
											src="@/assets/images/icon/ico_sat_o.png"
										/>
										<img
											v-if="headerInfo[index + 26]?.result?.marking !== 'right'"
											src="@/assets/images/icon/ico_sat_x.png"
										/>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
				<div>
					<q-btn
						class="btn"
						label="문항 해설 보기"
						flat
						:onClick="
							() => {
								scoreVisible = false;
								scoreBtn = false;
								nextStep(false, 1);
							}
						"
					/>
				</div>
			</div>
		</q-page-container>
	</template>
</template>

<script setup>
import { historyBack } from '@/helpers/utils';
import splash from '@/components/template/splash.vue';
import { ref, onMounted, onUnmounted, watch, toRaw } from 'vue';
import { DialogStore } from '@/store/modules/dialog';
import modalLayer from '@/components/layouts/layer/modalLayer.vue';
import qbankHeaderVue from '@/components/qbank/header.vue';
import problemChoice from '@/components/qbank/problemChoice.vue';
import qbankAnswer from '@/components/qbank/qbankAnswer.vue';
import AnswerMarking from '@/components/qbank/answerMarking.vue';
import CsatHeader from '@/components/layouts/header/csatHeader.vue';
import wordCahrt from '@/components/chart/wordCahrt.vue';
import { getKrtExam, getKrtProblem } from '@/api/modules/qbank';
import dataToParse from '@/helpers/qbankParser/dataParse';
import {
	getHeaderTitle,
	getKreadScore,
	getHeaderText,
	getEtcInfo,
	getHeader,
} from '@/helpers/qbankParser/qbankDataParse';
import { useQuasar } from 'quasar';
import moment from 'moment';
import { soundEffect, soundTic } from '@/helpers/soundEffect';
import { StudyStore } from '@/store/modules/study';
import { useRouter, useRoute } from 'vue-router';
import cqBtn from '@/components/quasar/cqBtn.vue';
import _ from 'lodash';
import ProblemRelation from '@/components/qbank/problemRelation.vue';
import {
	analysis,
	difficult,
	drill,
	learningType,
} from '@/helpers/qbankParser/qbankMeta';
import {
	postSatStart,
	postSatEnd,
	postAnswer,
	getAnswer,
	checkProgress,
} from '@/api/modules/study';
import FloatingBtn from '@/components/quasar/floatingBtn.vue';
import FloatingNotify from '@/components/quasar/floatingNotify.vue';
import { getUserMain } from '@/api/modules/login';
import * as zzApi from '@/api/modules/login';
import { setHeaderNo4SAT } from '@/views/eval_qbank/exam_common.js';
import {
	monitoringLog,
	monitoringTodayLearningStudy,
} from '@/api/modules/monitoring';

const isLog = false;
// 학습준비화면 시간
const $q = useQuasar();
const router = useRouter();
const route = useRoute();
const loadingTime = 1000;
const store = DialogStore();
const studyStore = StudyStore();
const isLoading = ref(null);
const isProc = ref(null);
const isKreadVisible = ref(null);
const data = ref(null);
const diffTime = ref(null);
let startTime;
const time = ref(null);
const questionHeader = ref(null);
const bookNm = ref(null);
const resultData = ref([]);
let allProblems = [];
let notif = null;
let problemMaps = [];
let problems = {};
let baseProblems = {};
let drillProblems = {};
let inputIdx = ref(0);
let answer = ref({});
let tmpAnswer = ref({});
let visibleScoring = false; // 채점 표시

const arrHeaderNo = ref([]); // 지문 상단 번호
//TODO: 차후 스토어로 변경 필요
let problemOrder = ref(1);
let problem = ref(null);
let notiAnswer = null;
let notiInfo = null;
let notiNav = null;
let notiAdditionalNav = null;
let notiNavBack = null;
let notiScoring = null;
let notiType = 'first';
let isScored = false;
let isDrill = false;

const dialog = ref(false);
const videoDialog = ref(false);
const resultDialog = ref(false);
const relationId = ref(null);
const scrollAreaRef = ref(null);
const headerInfo = ref([]);

const isStart = ref(false);
const isPause = ref(true);
const scoreVisible = ref(false);

const nextBtn = ref(false);
const preBtn = ref(false);
const scoreBtn = ref(false);
const msgComp = ref(false);
const msg = ref('');
const msgIcon = ref(null);
const isChangeHeader = ref(false);
const bottomHide = ref(true);

let isViewMode = false;
let isAllChecked = false;

const headerList = ref({});
const baseTime = ref(0);

let cornerTime = {
	passageReadStartTs: null,
	passageReadEndTs: null,
	passageReadTime: 0,
	videoViewStartTs: null,
	videoViewEndTs: null,
	videoViewTime: 0,
	cornerLearningStartTs: null,
	cornerLearningEndTs: null,
	cornerLearningTime: 0,
};

const visibleAnswer = ref(false);

const randomAnswer = () => {
	const ran = Math.floor(Math.random() * 4) + 1;
	return ran === 1
		? '①'
		: ran === 2
		? '②'
		: ran === 3
		? '③'
		: ran === 4
		? '④'
		: '⑤';
};
const initCoreReading = (rs, sdata) => {
	// console.log('===initCoreReading 시작', rs, sdata);
	isLoading.value = false;
	if (sdata) {
		isStart.value = true;
	}
	const tmpEtcInfo = getEtcInfo(rs);
	data.value = {
		content: getHeaderText(rs),
		kread: tmpEtcInfo.kread,
		title: tmpEtcInfo.title,
		etcInfo: tmpEtcInfo,
		standardReadingTime: moment('2022-10-01 00:00:00')
			.add(tmpEtcInfo.solveTime, 's')
			.format('m분ss초'),
		solveTime: tmpEtcInfo.solveTime,
	};
	questionHeader.value = getHeader(rs);
	bookNm.value = tmpEtcInfo.bookNm;

	// if (!sdata) {
	//   setTimeout(() => {
	//     msg.value = '1번부터 4번까지 문제를 풀어보아요.';
	//   }, 1000)
	// }
};

const testStart = () => {
	startTime = moment();
	cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
	problems[problemOrder.value]['answerStartTs'] = moment().format(
		'YYYY-MM-DD HH:mm:ss'
	);
	problems[problemOrder.value]['cornerStartTs'] = moment().format(
		'YYYY-MM-DD HH:mm:ss'
	);
	// console.log(`startTime: ${startTime}, `);

	isStart.value = true;
	isPause.value = false;
	bottomHide.value = false;
	if (!isViewMode) {
		const _data = {
			examName: studyStore.process.exam.examCode,
			learningType: studyStore.process.exam.learningType,
			// examName: 'KRT_02_T1'
		};
		postSatStart(_data, () => {
			if (isLog) console.log('-슈눙-testStart-_data- :', _data);
		});
		//k.u.j 성장판 2.0 오늘의 학습 api call
		// monitoringTodayLearningStudy({
		//     learningHistorySeq: studyStore.process.exam.learningHistorySeq,
		//     eventTypeCode: 2,
		// });
	}
};

const updateHeaderList = () => {
	const headerBox = document.getElementById('header_box');
	if (!headerBox) {
		console.warn('[header_box] DOM not found - header not saved');
		return;
	}

	if (isChangeHeader.value) {
		headerList.value = {
			...headerList.value,
			[problems[problemOrder.value].headerId]: headerBox.innerHTML,
		};
		isChangeHeader.value = false;
	}
};

const nextStep = (v = true, no = -1) => {
	isProc.value = true;
	soundEffect('next');

	if (
		!isScored &&
		no == -1 &&
		problems[problemOrder.value] &&
		problems[problemOrder.value]['result'] === null
	) {
		problems[problemOrder.value]['elapsedTime'] =
			problems[problemOrder.value]['elapsedTime'] +
			moment.duration(moment().diff(startTime)).asMilliseconds();
		problems[problemOrder.value]['answerEndTs'] = moment().format(
			'YYYY-MM-DD HH:mm:ss'
		);
	}
	problems[problemOrder.value]['cornerElapsedTime'] =
		problems[problemOrder.value]['cornerElapsedTime'] +
		moment.duration(moment().diff(startTime)).asMilliseconds();
	problems[problemOrder.value]['cornerEndTs'] = moment().format(
		'YYYY-MM-DD HH:mm:ss'
	);
	startTime = moment();
	if (
		no == -1 &&
		problems[problemOrder.value] &&
		problems[problemOrder.value]['result'] !== null
	) {
		problems[problemOrder.value]['completeYn'] = true;
	}

	// if (isLog) console.log('-슈눙-  - nextStep:', problems[problemOrder.value]);

	if (notiType === 'last' && v) {
		updateHeaderList();
		return submitAnswer(problemOrder.value, true);
		// return router.push('/authenticreading');
	}

	if (no === -1) {
		updateHeaderList();
		submitAnswer(problemOrder.value);
	}

	if (no !== -1) {
		problemOrder.value = Number(no);
	} else if (!v) {
		problemOrder.value = problemOrder.value - 1;
	} else {
		problemOrder.value = problemOrder.value + 1;
	}

	if (!problems[problemOrder.value]['answerStartTs']) {
		problems[problemOrder.value]['answerStartTs'] = moment().format(
			'YYYY-MM-DD HH:mm:ss'
		);
	}
	if (!problems[problemOrder.value]['cornerStartTs']) {
		problems[problemOrder.value]['cornerStartTs'] = moment().format(
			'YYYY-MM-DD HH:mm:ss'
		);
	}

	questionHeader.value === getHeader(problems[problemOrder.value].data);
	if (problemOrder.value === 1) {
		notiType = 'first';
		// questionHeader.value = getHeader(problems[(problemOrder.value)].data);
	} else if (problemOrder.value === Object.keys(problems).length) {
		notiType = 'last';
	} else {
		notiType = 'middle';
	}
	// problemOrder.value = problemOrder.value = 2;
	// getKrtProblem({
	//   version: '1.00.01', problemId: problemMaps[problemOrder.value].problemId
	// }, setProblem)
	problem.value = {
		...problems[problemOrder.value],
	};

	if (problems[problemOrder.value]['completeYn']) {
		notiType !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
		nextBtn.value = true;
	} else if (problems[problemOrder.value]['answer'] !== null && !isScored) {
		notiType !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
		notiType !== 'last' ? (nextBtn.value = true) : (nextBtn.value = false);
	} else if (!problems[problemOrder.value]['completeYn'] || isScored) {
		preBtn.value = false;
		nextBtn.value = false;
	} else {
		notiType !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
		notiType !== 'last' ? (nextBtn.value = true) : (nextBtn.value = false);
	}
	// setNotiNavigation(problems[problemOrder.value]);

	// notiNav !== null && notiNav();
	// notiNavBack !== null && notiNavBack();
	// notiNav = null;
	// notiNavBack = null;
	// startTime = moment();

	setScrollPosition();
	isProc.value = false;
};

const initExams = (sdata = null) => {
	getKrtExam(
		{
			// version: '1.00.01', examNm: 'KRT_02_17_N_02_C'
			version: studyStore.exprVersion,
			examNm: studyStore.process.exam.examCode,
			// version: studyStore.exprVersion, examNm: 'KRT_02_T1'
		},
		async rs => {
			// console.log('--initExams-rs-', rs);
			// TODO: store 에 코어리딩 문제 저장
			// rs.examMaps
			if (rs && rs.examMaps) {
				const exId = rs.examIds[0];
				const problemArr = rs.examMaps[exId];

				let sOrder = 1;
				let tmpElapsedTime = 0;
				let lastProblem = {};
				if (sdata) {
					let sdataIdxs = [];
					sdata.forEach(i => {
						sdataIdxs.push(i.problemId);
						if (i.answerStatus === 'COMPLETE') {
							isScored = true;
						}
						if (i.completeYn) {
							lastProblem = i;
						}
						tmpElapsedTime += Number(i.elapsedTime);
					});
					if (sdataIdxs.length > 33) {
						isAllChecked = true;
					}

					problemArr.forEach((item, index) => {
						if (sdataIdxs.includes(item.problemId)) {
							if (isScored) {
								if (lastProblem.problemId === item.problemId) {
									sOrder = index + 1;
								}
							} else {
								sOrder = index + 1;
							}
						}
					});
				}
				let tmpPdata = {};
				await Promise.all(
					problemArr.map((item, index) => {
						return getKrtProblem(
							{
								version: studyStore.exprVersion,
								problemId: item.problemId,
								// version: '1.00.01', problemId: 382222
							},
							r => {
								let pData = {
									problemNo: index + 1,
									problemId: r.content.problemId,
									analysisOrd: item.analysisOrd,
									etcInfo: getEtcInfo(r),
									data: r,
									questionHeader: getHeader(r),
									type: studyStore.process.exam.ln,
									elapsedTime: 0,
									answer: null,
									// 테스트를 위해 임시 답 생성
									// answer: randomAnswer(),
									reAnswer: null,
									videoTime: 0,
									relationResult: null,
									// 하단 네비 조정을 위한 변수
									result: null, // 채점 여부및 1,2차 정오답
									completeYn: false, // 채점및 풀이 확인 완료여부
									scrollCheck: false, // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
									relationId:
										r.content.property.problem?.relations?.length > 0
											? r.content.property.problem?.relations[0].relationId
											: null, // 확인 문제 있는지 여부
									// relationId: null,           // 확인 문제 있는지 여부
									completeVideo: false, // 영상 시청 여부
									correct: r.content.solution.answer.detail[0].answer,
									// TODO: 큐뱅크 해설영상 파싱필요
									// videoUrl: null,              // 해설 영상 여부
									videoUrl: r.content.property.problem.listen.includes('mp4')
										? process.env.VUE_APP_DS_QBANK_ASSET_URL +
										  r.content.property.problem.listen
										: null,
									// videoUrl: r.content.property.problem.listen !== '' ? process.env.VUE_APP_DS_QBANK_ASSET_URL + r.content.property.problem.listen : null,
									// videoUrl: 'https://media5jvqbd.fmkorea.com/files/attach/new2/20210301/2063168106/62449231/3424305738/b1b4e7075cece7bf3b0174253e99b524.mp4#t=1, 10',              // 해설 영상 여부
									problemClassCode: '1',
									headerId: r.content.property.header.headerId,
									answerStartTs: null,
									cornerStartTs: null,
									cornerEndTs: null,
									cornerElapsedTime: null,
								};
								// console.log('--initExams-pData-', pData);

								// headerList.value = { ...headerList, [r.content.property.header.headerId]: getHeader(r) }

								if (sdata) {
									const tmpData = [...sdata]
										.filter(i => i.problemId === r.content.problemId)
										.pop();
									if (tmpData) {
										pData = {
											...pData,
											completeYn: tmpData.completeYn,
											answer: tmpData.answer,
											correctYn: tmpData.correctYn,
											result:
												tmpData.answerStatus === 'COMPLETE'
													? {
															marking: tmpData.correctYn ? 'right' : 'wrong',
															answer: tmpData.answer,
													  }
													: null,
											elapsedTime: tmpData.elapsedTime,
											answerStartTs: tmpData.answerStartTs,
											answerEndTs: tmpData.answerEndTs,
											problemClassCode: tmpData.problemClassCode,
											cornerElapsedTime: tmpData.cornerElapsedTime,
											cornerStartTs: tmpData.cornerStartTs,
											cornerEndTs: tmpData.cornerEndTs,
										};
										headerInfo.value = {
											...headerInfo.value,
											[index + 1]: pData,
										};
									} else {
										headerInfo.value = {
											...headerInfo.value,
											[index + 1]: { answer: null, correctFlag: null },
										};
									}
									if (tmpData?.reviewContents) {
										headerList.value = {
											...headerList.value,
											[pData.headerId]: tmpData?.reviewContents,
										};
									}
								} else {
									headerInfo.value = {
										...headerInfo.value,
										[index + 1]: { answer: null, correctFlag: null },
									};
								}
								tmpPdata = {
									...tmpPdata,
									[index + 1]: pData,
								};
							}
						);
					})
				);
				problems = tmpPdata;
				setHeaderNo4SAT(arrHeaderNo, tmpPdata); // 지문에 번호달기

				if (sdata && sOrder) {
					// console.log(sOrder);
					// console.log(problems);
					// console.log(problems[sOrder]);
					problemOrder.value = sOrder;
					problem.value = problems[sOrder];
					initCoreReading(problems[sOrder]?.data, sdata);
					baseTime.value = Math.round(tmpElapsedTime);
					if (!isScored) {
						isPause.value = false;
						bottomHide.value = false;
					}
					if (problems[sOrder].completeYn || !isScored) {
						sOrder !== 1 && (preBtn.value = true);
						nextBtn.value = true;
						if (sOrder === 34) {
							if (!isScored) {
								nextBtn.value = false;
							}
							notiType = 'last';
						} else if (sOrder === 1) {
							notiType = 'first';
						} else {
							notiType = 'middle';
						}
					}
					if (isAllChecked && !isScored) {
						scoreBtn.value = true;
					}
				} else {
					initCoreReading(problems[1].data, sdata);
					problem.value = problems[1];
				}
			}
		}
	);
};

const init = () => {
	isLoading.value = true;
	// setTimeout(() => { initExams(); }, 1000);
	if (studyStore.currentInfo !== null) {
		isViewMode = true;
		getAnswer(
			{
				type: 'sat',
				data: {
					examName: studyStore.currentInfo.exam.examCode,
					learningType: studyStore.currentInfo.exam.learningType,
				},
			},
			r => {
				setTimeout(() => {
					initExams(r);
				}, 1000);
			}
		);
	} else {
		if (studyStore.process.exam.learningStatus === 'I') {
			getAnswer(
				{
					type: 'sat',
					data: {
						examName: studyStore.process.exam.examCode,
						learningType: studyStore.process.exam.learningType,
					},
				},
				r => {
					if (r?.length > 0) {
						setTimeout(() => {
							initExams(r);
						}, 1000);
					} else {
						setTimeout(() => {
							initExams();
						}, 1000);
					}
				}
			);
		} else if (studyStore.process.exam.learningStatus === 'C') {
			isViewMode = true;
			getAnswer(
				{
					type: 'sat',
					data: {
						examName: studyStore.process.exam.examCode,
						learningType: studyStore.process.exam.learningType,
					},
				},
				r => {
					if (r?.length > 0) {
						setTimeout(() => {
							initExams(r);
						}, 1000);
					} else {
						setTimeout(() => {
							initExams();
						}, 1000);
					}
				}
			);
		} else if (studyStore.process.exam.learningStatus === 'W') {
			setTimeout(() => {
				initExams();
			}, 1000);
		}
	}
};
onMounted(() => {
	console.log('onMounted sat');
	init();

	let data = {
		menuName: route.path.split('/').join(''),
		learningTypeCode: learningType[studyStore.process.exam.learningType].code,
		examName: studyStore.process.exam.examCode,
	};
	monitoringLog(data, res => {
		console.log('sat monitoringLog API response ===', res);
	});

	if (
		process.env.NODE_ENV === 'local' ||
		process.env.NODE_ENV === 'development' ||
		localStorage.getItem('videoSuperPass')
	) {
		visibleAnswer.value = true;
	}
});

const answerNoti = () => {
	notiAnswer !== null && notiAnswer();
	notiAnswer = null;
	scoreBtn.value = true;
};

onUnmounted(() => {
	isLoading.value = true;
});

watch(
	() => studyStore.process,
	newValue => {
		isLoading.value = true;
		if (studyStore.currentInfo !== null) {
			isViewMode = true;
			getAnswer(
				{
					type: 'sat',
					data: {
						examName: studyStore.currentInfo.exam.examCode,
						learningType: studyStore.currentInfo.exam.learningType,
					},
				},
				r => {
					setTimeout(() => {
						initExams(r);
					}, 1000);
				}
			);
		} else {
			if (studyStore.process.exam.learningStatus === 'I') {
				getAnswer(
					{
						type: 'sat',
						data: {
							examName: studyStore.process.exam.examCode,
							learningType: studyStore.process.exam.learningType,
						},
					},
					r => {
						if (r?.length > 0) {
							setTimeout(() => {
								initExams(r);
							}, 1000);
						} else {
							setTimeout(() => {
								initExams();
							}, 1000);
						}
					}
				);
			} else if (studyStore.process.exam.learningStatus === 'C') {
				getAnswer(
					{
						type: 'sat',
						data: {
							examName: studyStore.process.exam.examCode,
							learningType: studyStore.process.exam.learningType,
						},
					},
					r => {
						if (r?.length > 0) {
							setTimeout(() => {
								initExams(r);
							}, 1000);
						} else {
							setTimeout(() => {
								initExams();
							}, 1000);
						}
					}
				);
			} else if (studyStore.process.exam.learningStatus === 'W') {
				setTimeout(() => {
					initExams();
				}, 1000);
			}
		}
	}
);
watch(
	() => problem,
	newValue => {
		//
	}
);

const setAnswer = val => {
	// soundEffect('tic');

	problems[problemOrder.value]['answer'] = val;
	const tmpAnswerArr = _.filter(problems, item => {
		return item.answer === null;
	});
	if (tmpAnswerArr.length === 0) {
		isAllChecked = true;
		scoreBtn.value = true;
	}
	notiType !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
	notiType !== 'last' ? (nextBtn.value = true) : (nextBtn.value = false);
	headerInfo.value = {
		...headerInfo.value,
		[problemOrder.value]: { answer: val, correctFlag: null },
	};
};

const setQuestionsResult = () => {
	isProc.value = true;
	if (!problems[problemOrder.value]['answerEndTs']) {
		problems[problemOrder.value]['answerEndTs'] = moment().format(
			'YYYY-MM-DD HH:mm:ss'
		);
	}
	problems[problemOrder.value]['elapsedTime'] =
		problems[problemOrder.value]['elapsedTime'] +
		moment.duration(moment().diff(startTime)).asMilliseconds();
	startTime = moment();
	const tmpData = [];
	Object.entries(problems).forEach(([key, item]) => {
		const tmpIsRight =
			item.data.content.solution.answer.detail[0].answer === item.answer;
		if (tmpIsRight) {
			tmpData.push({
				no: item.analysisOrd,
				marking: 'right',
				analysis: item.data.content.property.analysis.analysisNm,
				difficult:
					difficult[item.data.content.property.analysis.difficultCd].label,
			});
		} else {
			tmpData.push({
				no: item.analysisOrd,
				marking: 'wrong',
				analysis: item.data.content.property.analysis.analysisNm,
				difficult:
					difficult[item.data.content.property.analysis.difficultCd].label,
			});
		}
		item.result = {
			marking: tmpIsRight ? 'right' : 'wrong',
			answer: item.answer,
		};
	});
	// 헤더에 정답여부셋
	headerInfo.value = { ...problems };
	const total = _.countBy(tmpData, i => {
		return i.marking === 'right' ? 'right' : 'wrong';
	});
	resultData.value = { ...total, data: tmpData };

	isScored = true;
	Object.entries(problems).forEach(([key, item]) => {
		submitAnswer(key, false, false);
	});

	scoreVisible.value = true;
	isPause.value = true;
	// isStart.value = false;
	isProc.value = false;
	if (isLog) console.log('-슈눙-  - setQuestionsResult  _data:');
};

// 스크롤 하단시 액션
const onIntersection = () => {
	if (problems[problemOrder.value]['scrollCheck'] !== true) {
		problems[problemOrder.value]['scrollCheck'] = true;
		if (problem.value?.result?.marking === 'right') {
			problems[problemOrder.value]['completeYn'] = true;
			problems[problemOrder.value]['completeVideo'] = true;
			notiType !== 'first' || isDrill
				? (preBtn.value = true)
				: (preBtn.value = false);
			nextBtn.value = true;
			headerInfo.value = { ...problems };
		} else {
			if (problems[problemOrder.value]['videoUrl'] !== null) {
				msgIcon.value = '';
				// msg.value = '확인해야 할 해설영상이 있어요!';
				msg.value = '문제풀이 영상을 확인하세요.';
			} else if (
				problems[problemOrder.value]['videoUrl'] === null &&
				problems[problemOrder.value]['relationId'] === null
			) {
				problems[problemOrder.value]['completeYn'] = true;
				notiType !== 'first' || isDrill
					? (preBtn.value = true)
					: (preBtn.value = false);
				nextBtn.value = true;
				headerInfo.value = { ...problems };
			} else {
				notiType !== 'first' || isDrill
					? (preBtn.value = true)
					: (preBtn.value = false);
				nextBtn.value = true;
			}
		}
		// setNotiNavigation(problems[problemOrder.value]);
	}
};

const setVideoStatus = () => {
	problems[problemOrder.value]['completeVideo'] = true;
	notiType !== 'first' || isDrill
		? (preBtn.value = true)
		: (preBtn.value = false);
	nextBtn.value = true;
	headerInfo.value = { ...problems };
	// setNotiNavigation(problems[problemOrder.value]);
	// console.log(problems[problemOrder.value]);
};

const setScrollPosition = (val = 0) => {
	try {
		scrollAreaRef.value.setScrollPosition('vertical', 0);
	} catch (error) {
		//
	}
};

const saveResult = () => {
	if (isLog) console.log('-슈눙-  - saveResult  :');

	//k.u.j 성장판 2.0 오늘의 학습 api call
	monitoringTodayLearningStudy({
		learningHistorySeq: studyStore.process.exam.learningHistorySeq,
		eventTypeCode: 3,
	});

	if (isViewMode) {
		router.push('/satreport');
	} else {
		const _data = {
			examName: studyStore.process.exam.examCode,
			learningType: studyStore.process.exam.learningType,
			// examName: 'KRT_02_T1',
		};
		postSatEnd(_data, async r => {
			studyStore.report.level = studyStore.process.exam?.level;
			studyStore.report.lesson = studyStore.process.exam?.lesson;
			studyStore.report.areaCode = studyStore.process.exam.areaCode;
			// TODO: 추천학습 맞춤학습이 확정되면 수정 필요
			// studyStore.report.learningTypeCode = learningType[studyStore.process.exam.learningType].code;
			studyStore.report.learningType = studyStore.process.exam.learningType;
			studyStore.report.learningHistorySeq = r.learningHistorySeq;

			/* KRT-1587 */
			const res = await zzApi.getUserMain2();
			if (res && res.status === 200) {
				const rs = res.data.data;

				if (rs.studyMain.length > 0) {
					let tmpMapTree = [];
					// let tmpStudy = { '01': [], '02': [] };
					rs.studyMain.forEach(element => {
						// tmpStudy[element.areaCode] = [...tmpStudy[element.areaCode], element];
						tmpMapTree.push({
							// examCode: element.learningType !== 'SAT' ? element.examName.slice(0, element.examName.length - 2) : element.examName,
							examCode: element.examName,
							version: rs.exprVersion,
							// TODO: 변경해야함
							headerEtcCd02: element.areaCode === '01' ? '05' : '02',
							headerEtcCd01: element.passageClass,
							passageClass: element.passageClass,
							area: element.areaCode === '01' ? '문학' : '비문학',
							title: element.passageName,
							areaCode: element.areaCode,
							isDone: false,
							learningStatus: element.learningStatus,
							learningType: element.learningType,
							difficult:
								element.areaCode === '01'
									? JSON.parse(element.difficultyL)
									: JSON.parse(element.difficultyN),
							satOrder: element?.satOrder ? element?.satOrder : null,
							groupIndex: element?.groupIndex ? element?.groupIndex : null,
							level: element?.level,
							lesson: element?.lesson,
						});
					});
					studyStore.level = rs.level;
					studyStore.lesson = rs.lesson;
					studyStore.exprVersion = rs.exprVersion;
					// console.log(tmpMapTree);
					studyStore.mapTree.exams = tmpMapTree;
					// studyStore.difficultyL = JSON.parse(rs.difficultyL);
					// studyStore.difficultyN = JSON.parse(rs.difficultyN);
					// TODO: 변경 필요함
					const fIndex = _.findIndex(rs.studyMain, function (o) {
						return o.examName === rs.currentStart.examName;
					});
					studyStore.process.examIdx = fIndex;
					if (rs.studyMain[fIndex].learningStatus === 'W') {
						studyStore.process.studyTree = 5082;
					}
					studyStore.process.problemOrd = 0;
					studyStore.process.exam = {
						// examCode: rs.currentStart.learningType !== 'SAT' ? rs.currentStart.examName.slice(0, rs.currentStart.examName.length - 2) : rs.currentStart.examName,
						examCode: rs.currentStart.examName,
						version: rs.exprVersion,
						// TODO: 변경해야함
						headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
						headerEtcCd01: rs.studyMain[fIndex].headerEtcCd01,
						passageClass: rs.studyMain[fIndex].passageClass,
						area: rs.currentStart.areaCode === '01' ? '문학' : '비문학',
						title: rs.studyMain[fIndex].passageName,
						areaCode: rs.currentStart.areaCode,
						isDone: false,
						learningHistorySeq: rs.currentStart.learningHistorySeq,
						learningType: rs.currentStart.learningType,
						learningStatus: rs.studyMain[fIndex]?.learningStatus,
						difficult:
							rs.currentStart.areaCode === '01'
								? JSON.parse(rs.studyMain[fIndex]?.difficultyL)
								: JSON.parse(rs.studyMain[fIndex]?.difficultyN),
						satOrder: rs.currentStart?.satOrder
							? rs.currentStart?.satOrder
							: null,
						groupIndex: rs.currentStart?.groupIndex
							? rs.currentStart?.groupIndex
							: null,
						level: rs.currentStart?.level,
						lesson: rs.currentStart?.lesson,
					};

					// console.log(studyStore);
					// postUserJson(JSON.stringify(studyStore.process), (rs) => {
					//   //
					// });

					router.push('/satreport');
				} else {
					router.push('/satreport');
				}
			}
			// getUserMain((rs) => {
			//     // console.log(rs)
			//     if (rs.studyMain.length > 0) {
			//         let tmpMapTree = [];
			//         // let tmpStudy = { '01': [], '02': [] };
			//         rs.studyMain.forEach((element) => {
			//             // tmpStudy[element.areaCode] = [...tmpStudy[element.areaCode], element];
			//             tmpMapTree.push({
			//                 // examCode: element.learningType !== 'SAT' ? element.examName.slice(0, element.examName.length - 2) : element.examName,
			//                 examCode: element.examName,
			//                 version: rs.exprVersion,
			//                 // TODO: 변경해야함
			//                 headerEtcCd02: element.areaCode === '01' ? '05' : '02',
			//                 headerEtcCd01: element.passageClass,
			//                 passageClass: element.passageClass,
			//                 area: element.areaCode === '01' ? '문학' : '비문학',
			//                 title: element.passageName,
			//                 areaCode: element.areaCode,
			//                 isDone: false,
			//                 learningStatus: element.learningStatus,
			//                 learningType: element.learningType,
			//                 difficult: element.areaCode === '01' ? JSON.parse(element.difficultyL) : JSON.parse(element.difficultyN),
			//                 satOrder: element?.satOrder ? element?.satOrder : null,
			//                 groupIndex: element?.groupIndex ? element?.groupIndex : null,
			//                 level: element?.level,
			//                 lesson: element?.lesson,
			//             });
			//         });
			//         studyStore.level = rs.level;
			//         studyStore.lesson = rs.lesson;
			//         studyStore.exprVersion = rs.exprVersion;
			//         // console.log(tmpMapTree);
			//         studyStore.mapTree.exams = tmpMapTree;
			//         // studyStore.difficultyL = JSON.parse(rs.difficultyL);
			//         // studyStore.difficultyN = JSON.parse(rs.difficultyN);
			//         // TODO: 변경 필요함
			//         const fIndex = _.findIndex(rs.studyMain, function (o) {
			//             return o.examName === rs.currentStart.examName;
			//         });
			//         studyStore.process.examIdx = fIndex;
			//         if (rs.studyMain[fIndex].learningStatus === 'W') {
			//             studyStore.process.studyTree = 5082;
			//         }
			//         studyStore.process.problemOrd = 0;
			//         studyStore.process.exam = {
			//             // examCode: rs.currentStart.learningType !== 'SAT' ? rs.currentStart.examName.slice(0, rs.currentStart.examName.length - 2) : rs.currentStart.examName,
			//             examCode: rs.currentStart.examName,
			//             version: rs.exprVersion,
			//             // TODO: 변경해야함
			//             headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
			//             headerEtcCd01: rs.studyMain[fIndex].headerEtcCd01,
			//             passageClass: rs.studyMain[fIndex].passageClass,
			//             area: rs.currentStart.areaCode === '01' ? '문학' : '비문학',
			//             title: rs.studyMain[fIndex].passageName,
			//             areaCode: rs.currentStart.areaCode,
			//             isDone: false,
			//             learningType: rs.currentStart.learningType,
			//             learningStatus: rs.studyMain[fIndex]?.learningStatus,
			//             difficult: rs.currentStart.areaCode === '01' ? JSON.parse(rs.studyMain[fIndex]?.difficultyL) : JSON.parse(rs.studyMain[fIndex]?.difficultyN),
			//             satOrder: rs.currentStart?.satOrder ? rs.currentStart?.satOrder : null,
			//             groupIndex: rs.currentStart?.groupIndex ? rs.currentStart?.groupIndex : null,
			//             level: rs.currentStart?.level,
			//             lesson: rs.currentStart?.lesson,
			//         };

			//         // console.log(studyStore);
			//         // postUserJson(JSON.stringify(studyStore.process), (rs) => {
			//         //   //
			//         // });

			//         router.push('/satreport');
			//     } else {
			//         router.push('/satreport');
			//     }
			// });
		});
	}
};

const submitAnswer = (num, end = false, chk = true) => {
	if (end) {
		nextBtn.value = false;
	}
	let tmpVal = { ...problems[num] };
	// console.log(problems[num]);
	let tmpCornerTime = {
		cornerLearningStartTs: problems[num].cornerStartTs,
		cornerLearningEndTs: problems[num].cornerEndTs,
		cornerLearningTime: problems[num].cornerElapsedTime,
	};
	if (tmpVal) {
		tmpVal.reAnswer = null;
		// if (isScored) {
		//   tmpVal.elapsedTime = null;
		//   tmpVal.answerStartTs = null;
		//   tmpVal.answerEndTs = null;
		// }
		if (headerList.value[tmpVal.headerId]) {
			tmpVal.reviewContents = headerList.value[tmpVal.headerId];
		}
		// tmpVal.reviewContents = isChangeHeader.value ? document.getElementById('header_box').innerHTML : null;
		tmpVal.correctYn =
			tmpVal.result === null ? null : tmpVal.result?.marking === 'right';
		tmpVal.reCorrectYn = null;
		tmpVal.answerStatus = isScored ? 'COMPLETE' : 'NOT_SCORE';

		delete tmpVal.data;
		delete tmpVal.result;
		delete tmpVal.rightAnswer;

		delete tmpVal.problemNo;
		delete tmpVal.analysisOrd;
		delete tmpVal.etcInfo;
		delete tmpVal.videoTime;
		delete tmpVal.relationResult;
		delete tmpVal.scrollCheck;
		delete tmpVal.relationId;
		delete tmpVal.completeVideo;

		delete tmpVal.videoUrl;
		delete tmpVal.completeVideo;
		delete tmpVal.questionHeader;
		delete tmpVal.type;
		delete tmpVal.headerId;

		delete tmpVal.cornerStartTs;
		delete tmpVal.cornerEndTs;
		delete tmpVal.cornerElapsedTime;

		const saveData = {
			examName: studyStore.process.exam.examCode,
			// examName: 'KRT_02_T1',
			exprVersion: studyStore.exprVersion,
			// learningType: 'SAT',
			learningType: studyStore.process.exam.learningType,
			cornerTime: tmpCornerTime,
			submission: { ...tmpVal },
		};
		// console.log(saveData);

		if (!isViewMode) {
			if (chk) {
				checkProgress(rs => {
					if (rs.modifyProgressFlag || rs.resetFlag) {
						store.openAlertDialog({
							// message: '학습 진도가 변경되었습니다.\n메인으로 이동합니다.',
							message:
								'학습 진도가 ' +
								(rs.modifyProgressFlag ? '수정' : '리셋') +
								'되었습니다.\n현재 학습이 끝나면 진도가 변경됩니다.',
							cancel: '닫기',
							ok: '확인',
							callback: () => {
								// router.push('/learninghome');
							},
						});
					} else {
						postAnswer({ type: 'sat', data: saveData }, () => {
							if (isLog)
								console.log(
									'-슈눙-  - Answer 11111:',
									problemOrder.value,
									saveData
								);
							if (end) {
								saveResult();
							}
						});
					}
				});
			} else {
				postAnswer({ type: 'sat', data: saveData }, () => {
					if (isLog)
						console.log(
							'-슈눙-  - Answer 22222:',
							problemOrder.value,
							saveData
						);
					if (end) {
						saveResult();
					}
				});
			}
		}

		// cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
	}
};
</script>

<style scoped lang="scss">
.word-chart_item {
	padding: 0px 20px;
	text-align: center;
}

.q-dialog__backdrop {
	width: 100vw;
	height: 100vh;
	top: 0px;
	position: fixed;
	z-index: 6000;
	pointer-events: all;
	outline: 0;
	background: rgb(23 20 20 / 40%);
}

.score {
	// display: grid;
	justify-content: center;
	text-align: center;
	align-items: center;
	// margin-top: 9.67vmin;
	display: block;
	width: 100%;

	&__container {
		position: absolute;
		width: 100%;
		height: 100vh;
		background-color: #f7f7f7;
		display: flex;
		align-items: center;
	}

	&__title {
		font-size: 2.8vw;
		font-weight: 700;
		line-height: 3.3vw;
	}

	&__desc {
		margin-top: 1.33vmin;
		font-size: 1.3vw;
		font-weight: 400;
		line-height: 2.1vw;
	}

	&__wrap {
		display: inline-flex;
		width: 60%;
		max-width: 1200px;
		min-width: 600px;
		margin-top: 2.33vmin;
	}

	&__item {
		background-color: white;
		border-radius: 1.33vmin;
		margin: 0 0.8vmin;
		width: calc(50% - 0.8min);
		padding: 2vmin;

		&__title {
			background-color: #f7f7f7;
			font-size: 1.2vw;
			font-weight: 700;
			line-height: 1.6vw;
			padding: 1.67vmin 0;
			width: 100%;
			border-radius: 0.67vmin;
		}

		&__wrap {
			display: flex;
			margin-top: 2.2vmin;
		}

		&__left {
			width: 50%;
			border-right: 1px solid #bdbdbd;
		}

		&__right {
			width: 50%;
		}
	}

	.result {
		display: flex;
		padding: 1.13vmin 0;
		font-size: 1.5vw;
		justify-content: center;
		align-items: center;

		&__num {
			font-weight: 500;
			line-height: 1.75vw;
			margin-right: 5.58vmin;
		}

		&__icon__wrap {
			width: 50%;
			display: inline-flex;
			align-items: center;
			justify-content: center;
		}

		img {
			width: 2.67vmin;
			height: 2.67vmin;
		}
	}

	.btn {
		background-color: $primary;
		color: white;
		font-size: 1.8vmin;
		padding: 2.75vmin 10.5vmin;
		border-radius: 1.33vmin;
		margin-top: 3.33vmin;
	}
}

p {
	margin-bottom: 0;
	line-height: inherit;
}

img {
	width: 100%;
}

.sat__content {
	justify-content: space-between;
	margin-top: 6.83vmin;
	box-sizing: border-box;

	.panel {
		align-items: center;
		width: calc((100% - 1.67vmin) / 2);
	}

	.h3 {
		width: 100%;
	}
}

.page {
	&__content {
		position: absolute;
		top: 50%;
		left: 0;
		width: 100%;
		@include transform(translateY(-50%));

		button {
			width: 100%;
			padding: 2.75vmin 2.83vmin;
			@include border-radius(1.33vmin);
			font-size: 1.2vw;
			font-weight: 700;
			line-height: 1.6vw;
		}
	}

	&__inner {
		width: 60%;
		max-width: 1178px;
		margin: 0 auto;
	}

	&__title {
		align-items: center;
		justify-content: center;
		text-align: center;

		.bold {
			font-size: 2.76vw;
			line-height: 3.35vw;
		}

		.title {
			margin: 1.33vmin 0 4.33vmin;
			font-family: Noto Serif KR;
			font-size: 4.5vw;
			font-weight: bold;
			line-height: 5vw;
		}

		.title_level {
			display: inline-block;
			margin: 0 auto;
			padding: 0.67vmin 2.58vmin;
			border: 1px solid $color_gray_900;
			border-radius: 6vmin;
			font-family: Noto Serif KR;
			font-size: 1.7vw;
			font-weight: 700;
			color: $black;
			line-height: 2.45vw;
		}

		.title_sub {
			margin: 1.33vmin 0;
			font-size: 1.8vw;
			color: #8e8e8e;
			line-height: 2.8vw;
		}

		.title_area {
			font-size: 4.5vw;
			line-height: 2.8vw;
			font-weight: 700;
			margin-bottom: 5vmin;
			font-family: Noto Serif KR;
		}
	}

	&__img {
		width: 47%;
		max-width: 188px;
	}

	&__txt {
		margin-top: 2.17vmin;
		padding: 4.17vmin 7vmin;
		font-size: 1.3vw;
		line-height: 2.25vw;
		text-align: center;
	}
}

.panel {
	overflow: hidden;
	border: 1px solid $color_gray_500;
	@include border-radius(1.33vmin);

	&__img {
		flex: 0 0 auto;
		width: 28%;
		max-width: 159px;
		height: 8.4vw;
		max-height: 168px;
		padding: 2vmin 1.67vmin;
		border-right: 1px solid $color_gray_500;
		background: $color_gray_200;
	}
}

.passage,
.answer {
	height: calc(100vh - 7.77vmin);
	margin-top: 1.99vmin;
}

.passage {
	+ .answer {
		&::before {
			content: '';
			position: absolute;
			top: 46%;
			left: 0;
			width: 1px;
			height: 91%;
			max-height: 974px;
			background: $color_gray_500;
			@include transform(translateY(-50%));
		}
	}
}

.answer {
	position: relative;
	// padding: 0 4.17vmin;

	&__scroll {
		padding: 0 5.17vmin 3.33vmin 4.08vmin;
		// padding-right: 5.17vmin;
		// padding-bottom: 3.33vmin;
	}

	&--next {
		width: 4.9vw;
		height: 4.9vw;
		margin-right: 3.33vmin;
	}

	&--prev {
		width: 3.5vw;
		height: 3.5vw;
		margin-left: 2.5vmin;
	}

	&--txt {
		padding: 2.75vmin 3.42vmin !important;
		margin-right: 3.33vmin;
		font-size: 1.2vw;
		font-weight: 700;
		line-height: 1.6vw;
	}
}

::v-deep {
	.q-scrollarea__content {
		padding-bottom: 3.33vmin;
	}

	.q-scrollarea__bar--v,
	.q-scrollarea__thumb--v {
		width: 0.3vw;
	}
}
</style>
